
(function(){
  // ---- variant picker ----
  document.querySelectorAll('[data-pdp]').forEach(function(root){
    var data;
    try{ data = JSON.parse(root.querySelector('[data-variants]').textContent); }catch(e){ return; }
    var form   = root.querySelector('form[action*="/cart/add"]');
    var idIn   = root.querySelector('[data-variant-id]');
    var priceEl= root.querySelector('[data-price]');
    var btn    = root.querySelector('[data-add]');
    var skuEl  = root.querySelector('[data-sku]');
    var money  = root.getAttribute('data-money') || '${{amount}}';

    function fmt(cents){
      var v=(cents/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',');
      return money.replace(/\{\{\s*amount\s*\}\}/,v);
    }
    function chosen(){
      return Array.prototype.map.call(root.querySelectorAll('[data-opt]'),function(g){
        var c=g.querySelector('input:checked'); return c?c.value:null;
      });
    }
    function match(sel){
      return data.find(function(v){
        return sel.every(function(val,i){ return val===null || v.options[i]===val; });
      });
    }
    function sync(){
      var v=match(chosen());
      if(!v){ btn.disabled=true; btn.textContent='Unavailable'; return; }
      idIn.value=v.id;
      priceEl.textContent=fmt(v.price);
      if(skuEl) skuEl.textContent=v.sku||'';
      if(v.available){ btn.disabled=false; btn.textContent='Add to cart'; }
      else { btn.disabled=true; btn.textContent='Sold out'; }
    }
    root.querySelectorAll('[data-opt] input').forEach(function(i){ i.addEventListener('change',sync); });
    sync();

    // quantity
    var q=root.querySelector('[data-qty]');
    if(q){
      root.querySelectorAll('[data-qstep]').forEach(function(b){
        b.addEventListener('click',function(){
          var n=parseInt(q.value,10)||1; n+=parseInt(b.getAttribute('data-qstep'),10);
          q.value=Math.max(1,n);
        });
      });
    }
  });

  // ---- gallery ----
  document.querySelectorAll('[data-gallery]').forEach(function(g){
    var main=g.querySelector('[data-gmain]');
    g.querySelectorAll('[data-gthumb]').forEach(function(t){
      t.addEventListener('click',function(){
        main.src=t.getAttribute('data-src');
        g.querySelectorAll('[data-gthumb]').forEach(function(o){o.setAttribute('aria-current','false');});
        t.setAttribute('aria-current','true');
      });
    });
  });
})();
